import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

/**
 * Shared page shell for narrow long-form pages (legal, etc).
 * Preserves the marble & gold aesthetic — dark bg, gold serif h1, cream body.
 */
export default function LegalPage({ eyebrow, title, updated, children, testid, path, metaDescription }) {
  return (
    <div className="relative z-10 mx-auto min-h-[100dvh] w-full max-w-2xl px-6 py-14" data-testid={testid}>
      <SEOHead title={title} description={metaDescription} path={path} />
      <p
        className="text-[11px] font-medium uppercase"
        style={{ color: "var(--muted)", letterSpacing: "0.32em" }}
      >
        {eyebrow}
      </p>
      <h1
        className="mt-3 font-serif text-[38px] leading-[1.05] sm:text-[46px]"
        style={{ color: "var(--gold)" }}
      >
        {title}
      </h1>
      {updated && (
        <p className="mt-2 text-[13px]" style={{ color: "var(--muted)" }}>
          Last updated · {updated}
        </p>
      )}

      <div className="legal-body mt-10" style={{ color: "var(--text)" }}>
        {children}
      </div>

      <div className="mt-14">
        <Link to="/" className="btn-ghost inline-flex" data-testid="legal-home-link">
          Back to home
        </Link>
      </div>

      <Footer />
    </div>
  );
}
